import attachment from "./attachment";
import brands from "./brand";
import call from "./call";
import brokers from "./brokers";
import categoryWeight from "./category-weight";
import commissionStatements from "./commission-statements";
import contacts from "./contacts";
import contracts from "./contracts";
import costs from "./costs";
import coverageCategories from "./coverage-categories";
import coverageMappings from "./coverage-mappings";
import coverages from "./coverages";
import coverageBenefits from "./coverages-benefits";
import distributions from "./distributions";
import events from "./events";
import geoZones from "./geo-zones";
import flows from "./flows";
import insurancePlanCoverages from "./insurance-plan-coverages";
import insurancePlans from "./insurance-plans";
import links from "./link";
import notes from "./notes";
import notifications from "./notifications";
import offers from "./offers";
import organizations from "./organizations";
import pricers from "./pricers";
import processes from "./processes";
import projects from "./projects";
import qualifications from "./qualifications";
import qualifiers from "./qualifiers";
import quotes from "./quotes";
import reminders from "./reminders";
import sources from "./sources";
import stores from "./stores";
import subscriptions from "./subscription";
import tasks from "./task";
import template from "./template";
import tracers from "./tracers";
import users from "./users";
import workflows from "./workflows";
import ageBrackets from "./age-brackets";
import crmCampaigns from "./crm-campaigns";
import crmLeadsMutations from "./crm-leads";
import crmSchedules from "./crm-schedules";
import crmSenders from "./crm-senders";
import crmSequences from "./crm-sequences";
import crmSteps from "./crm-steps";
import crmTemplates from "./crm-templates";
import regimes from "./regimes";
import zones from "./zones";

const mutations = {
  ...contracts,
  ...organizations,
  ...users,
  ...projects,
  ...sources,
  ...flows,
  ...processes,
  ...tracers,
  ...contacts,
  ...notes,
  ...insurancePlans,
  ...insurancePlanCoverages,
  ...coverages,
  ...coverageBenefits,
  ...costs,
  ...qualifiers,
  ...qualifications,
  ...reminders,
  ...quotes,
  ...subscriptions,
  ...attachment,
  ...brokers,
  ...call,
  ...workflows,
  ...pricers,
  ...commissionStatements,
  ...categoryWeight,
  ...coverageCategories,
  ...coverageMappings,
  ...distributions,
  ...offers,
  ...links,
  ...template,
  ...brands,
  ...stores,
  ...events,
  ...tasks,
  ...geoZones,
  ...notifications,
  ...zones,
  ...ageBrackets,
  ...crmCampaigns,
  ...crmSequences,
  ...crmSteps,
  ...crmSenders,
  ...crmSchedules,
  ...crmTemplates,
  ...crmLeadsMutations,
  ...regimes,
};

export default mutations;
